/* eslint-disable react/prop-types */
import React from 'react';
import classNames from 'classnames';
import { InputStyled, TextAreaStyled, FloatingLabel } from './styled';

const Input = ({ className = '', floating = false, label = '', ...props }) => (
  <>
    <FloatingLabel className={classNames(floating && '-show')}>{label}</FloatingLabel>
    <InputStyled className={classNames('Input', floating && '-floating', className)} {...props} />
  </>
);
Input.displayName = 'Input';
export default Input;

export const TextArea = ({ className = '', ...props }) => (
  <TextAreaStyled className={classNames('TextArea', className)} {...props} />
);
TextArea.displayName = 'TextArea';
